import { render, staticRenderFns } from "./SuccessfullyModel.vue?vue&type=template&id=5b915533"
import script from "./SuccessfullyModel.vue?vue&type=script&lang=js"
export * from "./SuccessfullyModel.vue?vue&type=script&lang=js"
import style0 from "./SuccessfullyModel.vue?vue&type=style&index=0&id=5b915533&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports